import { useAccountContext } from '../useAccountContext';

export const useCanSberIdLink = () => {
  const { currentCompany } = useAccountContext();

  return Boolean(currentCompany?.canSberIdLink);
};
